<template>
  <section class="page-section">
    <!-- filter -->
    <div class="filter-region no-margin-top">
      <div class="filter-form">
        <el-form
          size="small"
          :inline="true"
          :model="filterForm"
          ref="filterForm"
        >
          <el-form-item label="时间：" prop="time" class="auto-width">
            <el-date-picker
              v-model="filterForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input
              v-model="filterForm.mobile"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="filter-btn">
        <el-button-group class="btn-group">
          <el-button
            plain
            class="btn-reset"
            icon="el-icon-refresh"
            @click="filterFormReset('filterForm')"
          ></el-button>
          <el-button
            type="primary"
            class="btn-search"
            @click="filterFormSubmit('filterForm')"
            :loading="tableLoading"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>

    <!-- table -->
    <div class="table-region last-text-align-right" v-loading="tableLoading">
      <el-table size="small" :data="tableData" ref="multipleTable">
        <el-table-column label="时间">
          <template slot-scope="scope">
            <p>{{ scope.row.time }}</p>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <p>{{ scope.row.mobile }}</p>
          </template>
        </el-table-column>
        <el-table-column label="行为" align="right">
          <template slot-scope="scope">
            <p>{{ scope.row.operation }}</p>
          </template>
        </el-table-column>
        <el-table-column label="IP地址">
          <template slot-scope="scope">
            <p>{{ scope.row.ipAddress }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作详情">
          <template slot-scope="scope">
            <p>{{ scope.row.operation_detail }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table-footer" v-if="page.total > 0">
      <div class="selection-operate"></div>

      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 50, 100]"
          :pager-count="5"
          :current-page="page.current"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import { recordList } from "../../../common/api";

export default {
  data() {
    return {
      filterForm: {
        time: "", // 操作起止时间点
        name: "", // 姓名
        mobile: "", // 手机号
      },
      tableLoading: false,
      tableData: [], //表格数据

      page: {
        // 分页参数
        current: 1,
        size: 20,
        total: 0,
      },
      tableHeight: 400,
    };
  },
  methods: {
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]}          [description]
     */
    getList: function () {
      this.tableLoading = true;

      let param = {
        startDate: this.filterForm.time ? this.filterForm.time[0] : "",
        endDate: this.filterForm.time ? this.filterForm.time[1] : "",
        name: this.filterForm.name,
        mobile: this.filterForm.mobile,
        pageNo: this.page.current,
        pageSize: this.page.size,
      };

      recordList(param)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.tableData = data.records || [];
            this.page.total = data.total;
            this.$nextTick(() => {
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [calcTableHeight description] 动态计算表格高度
     * @return {[type]} [description]
     */
    // calcTableHeight() {
    //   const tableRegion = document.querySelector('.table-region')
    //   const tableFooter = document.querySelector('.table-footer')
    //   if (tableRegion) {
    //     const regionHeight = tableRegion.clientHeight
    //     const footerHeight = tableFooter ? tableFooter.offsetHeight : 0
    //     // 减去上下间距
    //     this.tableHeight = regionHeight - footerHeight - 20
    //     this.$nextTick(() => {
    //       this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
    //     })
    //   }
    // }
  },
  mounted() {
    this.getList();
    // this.$nextTick(() => {
    //   this.calcTableHeight()
    // })
    // window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calcTableHeight)
  },
};
</script>

<style lang="scss" scoped>
// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;
// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }
  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}
</style>
